import { Link } from '@farol-ds/react'
import { useCallback, useEffect, useState } from 'react'

import { redirectTo } from '../../utils/redirect'
import { LoginCard } from '../login-card'
import styles from './password-reset-success.module.scss'

const REDIRECT_SECONDS = 5

export function PasswordResetSuccess() {
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS)
  const goHome = useCallback(() => {
    redirectTo('/')
  }, [])

  useEffect(() => {
    if (countdown <= 0) {
      goHome()
      return
    }
    const intervalId = setInterval(() => setCountdown((c) => c - 1), 1000)
    return () => clearInterval(intervalId)
  }, [countdown, goHome])

  const header = {
    title: 'Senha alterada com sucesso',
    className: styles.headerCompactSpacing,
    subtitle: {
      asChild: true,
      content: <h2>Você será redirecionado(a) para a página inicial em {countdown} segundo(s).</h2>,
    },
  }

  return (
    <LoginCard header={header} hideCloseButton>
      <div className={styles.body}>
        <Link href="/" className={styles.link}>
          Ir para Jusbrasil
        </Link>
      </div>
    </LoginCard>
  )
}
